import { RefObject, useCallback, useEffect, useState } from 'react';

interface Options {
  parentRef: RefObject<$TSFixMe>;
  presentationRef: RefObject<$TSFixMe>;
  children: $TSFixMe;
}

const useResponsiveSizing = ({
  parentRef,
  presentationRef,
  children,
}: Options) => {
  const getSizing = useCallback(() => {
    var itemWidth = presentationRef.current.offsetWidth / children.length;
    var limit = Math.floor(parentRef.current.offsetWidth / itemWidth);
    return { itemWidth, limit };
  }, [children.length, parentRef, presentationRef]);

  const [sizing, setSizing] = useState(getSizing);

  useEffect(() => {
    const onResize = () => {
      setSizing(getSizing());
    };

    onResize();
  }, [getSizing, parentRef.current.offsetWidth]);

  return sizing;
};

export default useResponsiveSizing;
